import { useMediaQuery } from './useMediaQuery';

export const breakpoints = {
  m: '(max-width: 767px)',
  t: '(min-width: 768px) and (max-width: 1023px)',
  d: '(min-width: 1024px)',
};

export const useBreakpoint = (breakpointKey) => {
  return useMediaQuery(breakpoints[breakpointKey]);
}
